// extracted by mini-css-extract-plugin
export var container = "_5g-0";
export var outlet = "_5g-1";
export var outletEnter = "_5g-2";
export var outletEnterActive = "_5g-3";
export var outletExit = "_5g-4";
export var outletExitActive = "_5g-5";